// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tcsForm__tabs {
  display: flex;
  gap: 4px;
  padding: 0 0 12px;
  border-bottom: 1px solid #e1e7ed;
}
.tcsForm__tabs button {
  padding: 8px 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64778a;
  font-size: 12.5px;
  font-weight: 750;
}
.tcsForm__tabs button.is-active {
  background: #eaf4fb;
  color: #176fa7;
}
.tcsForm__panel {
  padding-top: 15px;
}
.tcsForm__label {
  display: block;
  margin: 0 0 6px;
  color: #344b61;
  font-size: 12px;
  font-weight: 750;
}
.tcsForm__text {
  width: 100%;
  height: 40px;
  padding: 0 11px;
  border: 1px solid #ccd7e1;
  border-radius: 8px;
}
.tcsForm__dateRow {
  display: grid;
  grid-template-columns: 230px minmax(0, 1fr);
  margin-top: 14px;
  align-items: end;
  gap: 14px;
}
.tcsForm__dateRow .sit-dp__trigger {
  height: 40px;
}
.tcsForm__dateSwitch {
  display: flex;
  min-height: 40px;
  padding: 0 0 1px;
  border: 0;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
}
.tcsForm__dateSwitch > span {
  display: flex;
  flex-direction: column;
}
.tcsForm__dateSwitch b {
  color: #344b61;
  font-size: 12.5px;
}
.tcsForm__dateSwitch small {
  color: #748599;
  font-size: 11px;
}
.tcsForm__mediaGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 16px;
  gap: 14px;
}
.tcsForm__upload {
  display: flex;
  min-height: 92px;
  margin: 0;
  border: 1px dashed #bccbd8;
  border-radius: 10px;
  background: #f7fafc;
  color: #2879ac;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
  text-align: center;
}
.tcsForm__upload small {
  color: #7a8b9c;
  font-size: 11px;
  font-weight: 400;
}
.tcsForm__upload input {
  display: none;
}
.tcsForm__upload--photo {
  overflow: hidden;
}
.tcsForm__upload--photo img {
  width: 100%;
  height: 110px;
  object-fit: cover;
}
.tcsForm__file {
  display: flex;
  margin-top: 6px;
  padding: 6px 8px;
  border-radius: 7px;
  background: #f1f5f8;
  align-items: center;
  justify-content: space-between;
  font-size: 11.5px;
}
.tcsForm__file button,
.tcsForm__removePhoto {
  border: 0;
  background: transparent;
  color: #b24141;
  font-weight: 700;
}
.tcsForm__removePhoto {
  margin-top: 5px;
  padding: 0;
  font-size: 11.5px;
}
.tcsForm__panel--content {
  min-height: 500px;
  display: flex;
  flex-direction: column;
}
.tcsForm__panel--content > p {
  margin: 0 0 10px;
  color: #687b8e;
  font-size: 12px;
}
.tcsForm__panel--content .quillEditor-root {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.tcsForm__panel--content .quillEditor-root .ql-container {
  flex: 1 1 auto;
  min-height: 400px;
}
.tcsForm__panel--content .quillEditor-root .ql-editor {
  min-height: 390px;
}
@media (max-width: 700px) {
  .tcsForm__dateRow,
  .tcsForm__mediaGrid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminSUView/Tournaments/TournamentForm/TournamentCustomSectionForm/TournamentCustomSectionForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;;EAEE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".tcsForm__tabs {\n  display: flex;\n  gap: 4px;\n  padding: 0 0 12px;\n  border-bottom: 1px solid #e1e7ed;\n}\n.tcsForm__tabs button {\n  padding: 8px 12px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #64778a;\n  font-size: 12.5px;\n  font-weight: 750;\n}\n.tcsForm__tabs button.is-active {\n  background: #eaf4fb;\n  color: #176fa7;\n}\n.tcsForm__panel {\n  padding-top: 15px;\n}\n.tcsForm__label {\n  display: block;\n  margin: 0 0 6px;\n  color: #344b61;\n  font-size: 12px;\n  font-weight: 750;\n}\n.tcsForm__text {\n  width: 100%;\n  height: 40px;\n  padding: 0 11px;\n  border: 1px solid #ccd7e1;\n  border-radius: 8px;\n}\n.tcsForm__dateRow {\n  display: grid;\n  grid-template-columns: 230px minmax(0, 1fr);\n  margin-top: 14px;\n  align-items: end;\n  gap: 14px;\n}\n.tcsForm__dateRow .sit-dp__trigger {\n  height: 40px;\n}\n.tcsForm__dateSwitch {\n  display: flex;\n  min-height: 40px;\n  padding: 0 0 1px;\n  border: 0;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 14px;\n}\n.tcsForm__dateSwitch > span {\n  display: flex;\n  flex-direction: column;\n}\n.tcsForm__dateSwitch b {\n  color: #344b61;\n  font-size: 12.5px;\n}\n.tcsForm__dateSwitch small {\n  color: #748599;\n  font-size: 11px;\n}\n.tcsForm__mediaGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  margin-top: 16px;\n  gap: 14px;\n}\n.tcsForm__upload {\n  display: flex;\n  min-height: 92px;\n  margin: 0;\n  border: 1px dashed #bccbd8;\n  border-radius: 10px;\n  background: #f7fafc;\n  color: #2879ac;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 2px;\n  text-align: center;\n}\n.tcsForm__upload small {\n  color: #7a8b9c;\n  font-size: 11px;\n  font-weight: 400;\n}\n.tcsForm__upload input {\n  display: none;\n}\n.tcsForm__upload--photo {\n  overflow: hidden;\n}\n.tcsForm__upload--photo img {\n  width: 100%;\n  height: 110px;\n  object-fit: cover;\n}\n.tcsForm__file {\n  display: flex;\n  margin-top: 6px;\n  padding: 6px 8px;\n  border-radius: 7px;\n  background: #f1f5f8;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11.5px;\n}\n.tcsForm__file button,\n.tcsForm__removePhoto {\n  border: 0;\n  background: transparent;\n  color: #b24141;\n  font-weight: 700;\n}\n.tcsForm__removePhoto {\n  margin-top: 5px;\n  padding: 0;\n  font-size: 11.5px;\n}\n.tcsForm__panel--content {\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n.tcsForm__panel--content > p {\n  margin: 0 0 10px;\n  color: #687b8e;\n  font-size: 12px;\n}\n.tcsForm__panel--content .quillEditor-root {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n}\n.tcsForm__panel--content .quillEditor-root .ql-container {\n  flex: 1 1 auto;\n  min-height: 400px;\n}\n.tcsForm__panel--content .quillEditor-root .ql-editor {\n  min-height: 390px;\n}\n@media (max-width: 700px) {\n  .tcsForm__dateRow,\n  .tcsForm__mediaGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
